import * as React from 'react';

export const Close = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h16v16H0z"/>
            <path fill="#674808" fillRule="nonzero" stroke="#674808" d="M8 7.293l3.146-3.147a.5.5 0 0 1 .708.708L8.707 8l3.147 3.146a.5.5 0 0 1-.708.708L8 8.707l-3.146 3.147a.5.5 0 0 1-.708-.708L7.293 8 4.146 4.854a.5.5 0 1 1 .708-.708L8 7.293z"/>
        </g>
    </svg>
);



// WEBPACK FOOTER //
// ./src/Assets/images/svg/Close.tsx